const FAILURE_STATUS_KEYWORDS = [
  'not possible',
  'not required',
  'acknowledged',
  "don't renew",
  'dont renew',
  'expired'
];

const IMMINENT_STATUS_KEYWORDS = [
  'expiry imminent'
];

const SUCCESS_STATUS_KEYWORDS = [
  'certified',
  'validity'
];

const AWAITING_APPROVAL_STATUSES = new Set([
  'awaiting approval',
  'waiting approval'
]);

const AWAITING_STATUS_KEYWORDS = [
  'awaiting',
  'waiting',
  'renewal requested'
];

const STATUS_ICON_PATHS = {
  blocked: 'assets/images/fail.png',
  imminent: 'assets/images/clock-sand.png',
  success: 'assets/images/green.png',
  awaitingApproval: 'assets/images/reload-red.png',
  awaiting: 'assets/images/reload-yellow.png'
} as const;

function containsAnyKeyword(status: string, keywords: string[]): boolean {
  return keywords.some((keyword) => status.includes(keyword));
}

export function normalizeCertificationStatus(status: string | null | undefined): string {
  return String(status || '')
    .replace(/Don.+?t/gi, "Don't")
    .replace(/\u2019/g, "'")
    .replace(/\s*\/\s*/g, ' / ')
    .replace(/\s+/g, ' ')
    .trim();
}

export function resolveCertificationStatusIcon(status: string | null | undefined): string | null {
  const normalizedStatus = normalizeCertificationStatus(status).toLowerCase();
  if (!normalizedStatus) return null;

  if (containsAnyKeyword(normalizedStatus, FAILURE_STATUS_KEYWORDS)) {
    return STATUS_ICON_PATHS.blocked;
  }

  if (containsAnyKeyword(normalizedStatus, IMMINENT_STATUS_KEYWORDS)) {
    return STATUS_ICON_PATHS.imminent;
  }

  if (AWAITING_APPROVAL_STATUSES.has(normalizedStatus)) {
    return STATUS_ICON_PATHS.awaitingApproval;
  }

  if (containsAnyKeyword(normalizedStatus, AWAITING_STATUS_KEYWORDS)) {
    return STATUS_ICON_PATHS.awaiting;
  }

  if (containsAnyKeyword(normalizedStatus, SUCCESS_STATUS_KEYWORDS)) {
    return STATUS_ICON_PATHS.success;
  }

  return null;
}
